import { Box, useBreakpointValue } from "@chakra-ui/react"
import Carousel from "./Carousels/Carousel";
import { CarouselcontainerStyles_t, MainCarouselImageListItem_t, MainImageCarouselProps } from "./Carousels/carousalTypes";
import banner from "../resources/images/banner.png"
import trikonasana from "../resources/images/trikonasana.png"
import sadhanaFood from "../resources/images/sadhana_food.png"
import consciouslyShoply from "../resources/images/consciously_shoply.png"
import donateBooks from "../resources/images/donateBooks.jpeg"
import { Link } from "react-router-dom";
import aLetterToSelf from '../resources/images/a-letter-to-self.png'
import elephant_in_the_room from '../resources/images/elephant_in_the_room.png'

export default function MainImageCarousel({ imageList = [
    {
        img: aLetterToSelf,
        size: "contain",
        position: "center",
        navigatableLink: "",
        alt: ""

    },
    {
        img: elephant_in_the_room,
        size: "contain",
        position: "center",
        navigatableLink: "",
        alt: ""

    },
    {
        img: trikonasana,
        size: "contain",
        position: "center",
        navigatableLink: "/learn/yoga/hatha-yoga",
        alt: ""
    },
    {
        img: consciouslyShoply,
        size: "contain",
        position: "center",
        navigatableLink: "",
        alt: ""
    },
    {
        img: donateBooks,
        size: { base: "contain", md: "90rem 35rem" },
        position: { base: "center", md: "center" },
        navigatableLink: "/learn/library",
        alt: ""
    }
]
}: MainImageCarouselProps) {

    const carouselContainerStyle: CarouselcontainerStyles_t = {
        position: "relative",
        height: useBreakpointValue({ base: "40vh", md: "80vh" })!,
        minHeight: useBreakpointValue({ base: "15rem", md: "40rem" })!,
        maxHeight: useBreakpointValue({ base: "50vh", md: "70vh" })!,
        width: 'full',
        overflow: 'hidden',
        zIndex: 0
    }

    const imageCard = (image: MainCarouselImageListItem_t, index: number) => {
        return <Box key={index}
             sx={{
                background: `linear-gradient(135deg, #ab40257b, #da9561)`,
                backgroundSize: image.size,
                backgroundRepeat: "no-repeat",
                backgroundPosition: image.position
            }}>
            <Box
                h={{ base: "15rem", md: "35rem" }}
                minH={{ base: "10rem", md: "38rem" }}
                maxH={{ base: "40vh", md: "50vH" }}
                mt={image.size === "100%" ? "0" : "0.5rem"}
                mb={image.size === "100%" ? "0" : "0.5rem"}
                position="relative"
                backgroundImage={image.img}
                backgroundSize={image.size}
                backgroundRepeat="no-repeat"
                bgPosition={image.position}
            >
            </Box>
        </Box>
    }

    const boxtToBeRendered = imageList.map((image, index) => (
        image.navigatableLink ? (
            <Link key={index} to={image.navigatableLink}>
                {imageCard(image, index)}
            </Link>
        ) : (
            imageCard(image, index)
        )
    ));


    return (<>
        <Carousel cards={boxtToBeRendered} containerStyles={carouselContainerStyle} />
    </>)
}


